import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { updateUser } from "../../../helpers/urlConfig/apiFunctions";
import { successToastify } from "../../../Components/Common/Toaster";
import { getSessionData } from "../../../helpers/sessionDetailsParser";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

function UserEdit({
  modal_list,
  setmodal_list,
  tog_list,
  fetchData,
  currentUser,
}) {
  const { register, handleSubmit, reset } = useForm({
    defaultValues: currentUser,
  });

  const onSubmit = async (data) => {
    try {
      data.updated_by = getSessionData("user_id");
      const response = await updateUser(data);

      if (response.statusCode === 200) {
        successToastify("User updated successfully!");
        fetchData();
        setmodal_list(false);
        reset();
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      // Handle error
      console.error("Error adding user:", error);
    }
  };

  return (
    <>
      <ToastContainer />
      <Modal
        isOpen={modal_list}
        toggle={() => {
          tog_list();
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          toggle={() => {
            tog_list();
          }}
        >
          Edit User
        </ModalHeader>
        <form className="tablelist-form" onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <div className="mb-3">
              <label htmlFor="productName" className="form-label">
                User Name
              </label>
              <input
                type="text"
                id="user_name"
                className="form-control"
                placeholder="Enter User Name"
                {...register("user_name", {
                  required: "User Name is required",
                })}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="phone_number" className="form-label">
                Mobile Number
              </label>
              <input
                type="number"
                id="phone_number"
                className="form-control"
                placeholder="Enter Mobile Number"
                {...register("phone_number", {
                  required: "Mobile Number is required",
                })}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="user_type" className="form-label">
                User Type
              </label>
              <select
                id="user_type"
                className="form-control"
                {...register("user_type", {
                  required: "User Type is required",
                })}
              >
                <option value="">Select User Type</option>
                <option value="SuperAdmin">Super Admin</option>
                <option value="Admin">Admin</option>
                <option value="User">User</option>
              </select>
            </div>

            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                type="text"
                id="password"
                className="form-control"
                placeholder="Enter Password"
                {...register("password", {
                  required: "Password is required",
                })}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setmodal_list(false)}
              >
                Close
              </button>
              <button type="submit" className="btn btn-success" id="add-btn">
                Edit User
              </button>
            </div>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
}

// Add prop types for validation
UserEdit.propTypes = {
  modal_list: PropTypes.bool.isRequired, // Indicates whether the modal is open
  setmodal_list: PropTypes.func.isRequired, // Function to toggle modal visibility
  tog_list: PropTypes.func.isRequired, // Function to toggle the modal
  fetchData: PropTypes.func.isRequired, // Function to fetch the updated product data
};

export default UserEdit;
